import { IAction } from '~/shared/store/types'
import { ISubscription } from '~/shared/types/subscriptionsTypes'

import {
  SET_SUBSCRIPTION,
  SET_SUBSCRIPTION_ID,
  SET_SUBSCRIPTION_LIST,
} from '../actionTypes'

export function setSubscriptionListAction(
  payload: ISubscription[],
): IAction<ISubscription[]> {
  return {
    type: SET_SUBSCRIPTION_LIST,
    payload,
  }
}

export const setSelectedSubscriptionAction = (
  payload: ISubscription | null,
): IAction<ISubscription | null> => ({
  type: SET_SUBSCRIPTION,
  payload,
})

export const setSubscriptionIdAction = (payload: string): IAction<string> => ({
  type: SET_SUBSCRIPTION_ID,
  payload,
})
